import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fz-game-card-image',
  templateUrl: './card-image.component.html',
  styleUrls: ['./card-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameCardImageComponent {
  @Input()
  image: string;
}
